import { combineReducers } from 'redux';

import auditorAssetId from './auditorAssetId';

const applied = combineReducers({
  auditorAssetId,
});

export default applied;
